import React, { useState, useEffect } from "react";
import axios from "axios";
import Sidebar from "./Sidebar"; // ✅ import Sidebar

function ChangePassword() {
  const [Id, setId] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [user, setUser] = useState(null); // ✅ for sidebar

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (storedUser) setUser(storedUser); // ✅ load user for sidebar
  }, []);

  const handleChangePassword = async (e) => {
    e.preventDefault();
    try {
      await axios.post("https://api.ssvdevelopers.co.in/auth/change-password", {
        Id,
        oldPassword,
        newPassword,
      });
      alert("✅ Password changed successfully!");
    } catch (err) {
      alert("❌ " + (err.response?.data?.error || "Something went wrong"));
    }
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      {/* Sidebar */}
      <Sidebar user={user} setUser={setUser} />

      {/* Main Content */}
      <div style={{ flex: 1, padding: "30px" }}>
        <h2>Change Password</h2>
        <form onSubmit={handleChangePassword} style={styles.form}>
          <input
            type="text"
            placeholder="ID"
            value={Id}
            onChange={(e) => setId(e.target.value)}
            style={styles.input}
            required
          />
          <input
            type="password"
            placeholder="Old Password"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            style={styles.input}
            required
          />
          <input
            type="password"
            placeholder="New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            style={styles.input}
            required
          />
          <button type="submit" style={styles.button}>Change Password</button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    maxWidth: "400px",
    margin: "0 auto",
    marginTop: "50px",
  },
  input: {
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
  },
  button: {
    padding: "10px",
    backgroundColor: "#2c3e50",
    color: "white",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
  },
};

export default ChangePassword;
